import { Card, CardContent, Typography } from "@mui/material";

interface KpiCardProps {
  label: string;
  value: string;
  tone?: "default" | "success" | "danger";
}

export default function KpiCard({ label, value, tone = "default" }: KpiCardProps) {
  const color =
    tone === "success" ? "success.main" : tone === "danger" ? "error.main" : "secondary.main";

  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        borderRadius: 2,
        borderColor: "rgba(84, 189, 193, 0.32)",
        background: "#fff",
      }}
    >
      <CardContent>
        <Typography variant="body2" color="text.secondary" fontWeight={700} gutterBottom>
          {label}
        </Typography>
        <Typography variant="h4" color={color} fontWeight={900}>
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
}
